var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{directives:[{name:"show",rawName:"v-show",value:(Boolean(_vm.registrationBadge)),expression:"Boolean(registrationBadge)"}],staticClass:"ml-2 bg-monza-500",attrs:{"pill":""}},[_vm._v(_vm._s(_vm.registrationBadge))])}
var staticRenderFns = []

export { render, staticRenderFns }